(function() {
  var elements = document.querySelectorAll('[data-animate="fade-in-up"]');

  if (!elements.length) return;

  var keyframes = [
    { opacity: 0, transform: 'translateY(20px)' },
    { opacity: 1, transform: 'translateY(0)' }
  ];

  function animateElement(el) {
    if (el.getAttribute('data-animated')) return;
    el.setAttribute('data-animated', 'true');

    var delay = parseInt(el.getAttribute('data-animate-delay')) || 0;
    var duration = parseInt(el.getAttribute('data-animate-duration')) || 600;

    el.animate(keyframes, {
      duration: duration,
      easing: 'ease-out',
      fill: 'forwards',
      delay: delay
    });
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateElement(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  elements.forEach(function(el) {
    observer.observe(el);
  });
})();
